import { createReducer, isFetched, isFetching } from "../../utils/reducer"
import {
	EXAMS_SET,
	EXAM_SET,
	EXAM_CLEAR,
	EXAMS_REQUEST,
	EXAMS_REQUEST_DONE,
	EXAM_COUNT_SET,
} from "../actions/examActions"

const initialState = {
	isFetching: false,
	// One entry per student the viewer can see papers for. A student has one
	// (themselves); a parent has one per child who actually has a visible
	// paper.
	groups: [],
	currentExam: null,
	count: 0,
}

export const setExams = (state, groups) => ({
	...state,
	groups: groups || [],
})

export const setExam = (state, exam) => ({
	...state,
	currentExam: exam,
})

export const clearExam = state => ({
	...state,
	currentExam: null,
})

export const setExamCount = (state, count) => ({
	...state,
	count: count || 0,
})

export default createReducer(initialState, {
	[EXAMS_SET]: setExams,
	[EXAM_SET]: setExam,
	[EXAM_CLEAR]: clearExam,
	[EXAMS_REQUEST]: isFetching,
	[EXAMS_REQUEST_DONE]: isFetched,
	[EXAM_COUNT_SET]: setExamCount,
})
